import { Injectable } from '@angular/core'
import { MatDrawerToggleResult, MatSidenav } from '@angular/material/sidenav'

@Injectable({
    providedIn: 'root'
})
export class SidenavService {
    // NOTE: sidenav is filled in an afterViewInit. We can assume this value is never undefined.
    private sidenav!: MatSidenav

    setSidenav(sidenav: MatSidenav): void {
        this.sidenav = sidenav
    }

    async open(): Promise<MatDrawerToggleResult> {
        return this.sidenav.open()
    }

    async close(): Promise<MatDrawerToggleResult> {
        return this.sidenav.close()
    }

    async toggle(): Promise<MatDrawerToggleResult> {
        return this.sidenav.toggle()
    }

    isOpen(): boolean {
        return this.sidenav.opened
    }
}
